import { List, ListItem, styled, Typography } from "@mui/material";
import Accordion from "./Accordion";
import SquarePlusIcon from "assets/images/SquarePlusIcon.svg";
import getCurrency from "helpers/currencyHelper";

interface Props {
  blocks: Block[];
  onItemClick: (item: BlockItem) => void;
}

export function currencyFormat(val: number, currency?: string) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        gap: "10px",
        direction: "ltr",
      }}
    >
      <span style={{ color: "#828282" }}>{currency || getCurrency().defCur.en_title}</span>
      <span style={{ color: "#1A1919" }}>{Intl.NumberFormat().format(val)}</span>
    </div>
  );
}

export const StyledListItem = styled(ListItem)(({ lastItem }: { lastItem: boolean }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "13px 24px",
  borderBottom: lastItem ? "none" : "1px solid #E0E0E0",
  cursor: "pointer",
}));

export function BlockTitle({ icon, text, color }: Title) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {icon}
      <Typography style={{ color }}>{text}</Typography>
    </div>
  );
}

export default function Blocks({ blocks, onItemClick }: Props) {
  return (
    <>
      {blocks.map((block, index) => {
        const { data, expanded, title } = block;
        const sum = block.sum;
        return (
          <Accordion key={index} title={BlockTitle(title)} expanded={expanded}>
            <List style={{ padding: 0 }}>
              {data &&
                data.map((item, i) => {
                  return (
                    <StyledListItem
                      lastItem={i === data.length - 1}
                      key={i}
                      onClick={() => onItemClick(item)}
                    >
                      <span>{item.label}</span>
                      <span>
                        {item.amount ? currencyFormat(item.amount) : <img src={SquarePlusIcon} alt="" />}
                      </span>
                    </StyledListItem>
                  );
                })}
              <StyledListItem
                lastItem={true}
                style={{ backgroundColor: "#F0F2F8", border: "1px solid #E0E0E0" }}
              >
                <span>مجموع</span>
                <span>{sum ? currencyFormat(sum) : 0}</span>
              </StyledListItem>
            </List>
          </Accordion>
        );
      })}
    </>
  );
}
